import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, defaultAddErrorMessage, errorTranslate } from "../util";

// ============================================
// LCA-SPECIFIC API FUNCTIONS (Flow 31.5)
// Losses for everything in this category
// ============================================

export const getAllProductLossesLCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/" + productId + "/losses-lca",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        response.data.data.map((data) => {
          return data;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const addProductLossesLCA = ({
  productId,
  own_name,
  material,
  amount,
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    own_name: own_name || null,
    material: material || null, // Material code from dropdown
    amount: amount || 0,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/product/" + productId + "/losses-lca",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
        setErrorMessage(error.response?.data);
      }
    });
};

export const updateProductLossesLCA = ({
  productId,
  lossesId,
  own_name,
  material,
  amount,
  objects,
  setObjects = function () {
    return;
  },
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    own_name: own_name || null,
    material: material || null, // Material code from dropdown
    amount: amount || 0,
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/losses-lca/" +
      lossesId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((item) => {
          if (response.data.data.id === item.id) {
            return response.data.data;
          }
          return item;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      setErrorMessage(error.response?.data);
    });
};

export const deleteProductLossesLCA = ({
  productId,
  lossesId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/losses-lca/" +
      lossesId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

